import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchShipmentsByThreadId } from "../../store/features/shipmentsSlice";

const RequiredActions = ({ threadId }) => {
  const dispatch = useDispatch();
  const { shipments, status } = useSelector((state) => state.shipments);
  const shipment = shipments.find((shipment) => shipment.thread_id === threadId);

  if (!shipment) {
    return <p>Loading...</p>; // Handle loading state
  }

  const hasIssue = shipment.issue;
  const Registered = shipment.CI;

  return (
    <div
      className={`bg-white border-2 p-4 rounded-md shadow-sm ${
        hasIssue ? "border-logo" : "border-[#357F3F]"
      }`}
    >
     {hasIssue ? (
        Registered ? (
          <>
            <p className="font-bold text-font mb-2">
              Required Action: System was unable to locate mandatory information.
            </p>
            <p className="text-font-hex">
              {/* Follow the link to review documents.{" "}
              <Link
                to={`/dashboard/process/${threadId}/1`}
                className="text-font-hex underline hover:text-logo"
              >
                Link
              </Link> */}
              
            </p>
          </>
        ) : (
          <>
            <p className="font-bold text-font mb-2">
              Required Action: Shipment is not yet registered.
            </p>
            <p className="text-font-hex">
              {/* Follow the link to finish shipment registration.{" "}
              <Link
                to={`/dashboard/register/${threadId}/1`}
                className="text-font-hex underline hover:text-logo"
              >
                Link
              </Link> */}
              Please complete shipment registration
            </p>
          </>
        )
      ) : (
        <>
          <p className="font-bold mb-2">No actions required:</p>
          <p className="text-font-hex">No further input is needed from the user.</p>
        </>
      )}
    </div>
  );
};

export default RequiredActions;
